<template>
  <div class="d-copy-cals text-dark">
    <div class="d-acc" :class="{'d-acc--open': isAccOpen}">
      <div class="d-acc__header" @click="toggleIsAccOpen">
        <div class="d-acc__header__left">
          <div class="d-toggle-arrow" :class="{'d-toggle-arrow--open': isAccOpen}"></div>
          <h3>{{ title }} ({{ calendarsExclArchived.length }})</h3>
        </div>
      </div>
      <ul class="d-copy-cals__list" v-if="isAccOpen">
        <li class="d-copy-cals__list__header">
          <p class="d-acc__header__select-all select-all-item " @click="toggleAllKlasses">
            <span v-if="selectedCalIds.length < 1">{{ $t('vue2.tagging.select_all') }}</span>
            <span v-else>{{ $t('vue2.tagging.unselect_all') }}</span>
          </p>
          <div class="d-copy-cals__list__header__right">
            <p>{{ selectedCalIds.length }} {{ $t('vue2.calendars.selected_of') }} {{ calendarsExclArchived.length }}</p>
            <button class="bttn--disabled hint--bottom-left"
                    :aria-label="this.$t('vue2.calendars.select_calendars_to_copy')"
                    v-if="selectedCalIds.length < 1">
              {{ $t('vue2.calendars.delete') }} {{ fromDateAndToDate }}
            </button>
            <button class="bttn bttn-danger hint--bottom-left"
                    aria-label="Both dates are included"
                    @click="deleteDays"
                    v-if="selectedCalIds.length > 0 && !isDeleting">
              <span class="icon-bin"></span>
              {{ $t('vue2.calendars.delete') }} {{ fromDateAndToDate }}
            </button>
            <button class="bttn--disabled bttn-danger bttn--with-spinner"
                    v-if="selectedCalIds.length > 0 && isDeleting">
              <Loader :is-extra-small="true" style="margin: 0 7px 0 0"></Loader>
              {{ $t('vue2.calendars.delete') }} {{ fromDateAndToDate }}
            </button>
          </div>
        </li>
        <li class="d-copy-cals__cal"
            v-for="calendar in calendarsExclArchived" :key="calendar.id"
            @click="toogleCal(calendar.id)"
            :class="{'d-copy-cals__cal--selected': getIsInSelectedCalIds(calendar.id)}">
          <div class="d-copy-cals__cal__selector">
            <div class="checkbox"></div>
          </div>
          {{ calendar.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import eventbus from '../../eventbus'
import docendo from '../../docendo'
import moment from 'moment'
import Datepickerrange from '../datepicker/DatePickerRange'
import Loader from '../common/Loader'

export default {
  components: {Loader, Datepickerrange},
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    calType: {
      type: String,
      default: 'klass'
    },
    calendars: {
      type: Array,
      default: () => []
    },
    toDate: {
      default: () => moment()
    },
    fromDate: {
      default: () => moment()
    }
  },
  data () {
    return {
      copyCalType: null,
      selectedCalIds: [],
      isDeleteEvents: true,
      isAccOpen: false,
      isArchivedAccOpen: false,
      isDeleting: false
    }
  },
  computed: {
    fromDateAndToDate () {
      return moment(this.fromDate).format('L') + ' to ' + moment(this.toDate).format('L')
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    calendarsExclArchived () {
      return this.calendars.filter(calendar => !calendar.archived_at)
    },
    archivedCalendars () {
      return this.calendars.filter(calendar => calendar.archived_at)
    },
    title () {
      switch (this.calType) {
        case 'klass':
          return this.$t('vue2.common.classes')
        case 'user':
          return this.$t('vue2.common.users')
        case 'room':
          return this.$t('vue2.common.rooms')
        case 'merge':
          return this.$t('vue2.common.merge_calendars')
        case 'other':
          return this.$t('vue2.common.other_calendars')
        default:
          return this.calType
      }
    }
  },
  methods: {
    getIsInSelectedCalIds (calId) {
      return this.selectedCalIds.indexOf(calId) > -1
    },
    toogleCal (calId) {
      let idx = this.selectedCalIds.indexOf(calId)
      if (idx < 0) {
        this.selectedCalIds.push(calId)
      } else {
        this.selectedCalIds.splice(idx, 1)
      }
    },
    toggleAllKlasses () {
      if (this.selectedCalIds.length > 0) {
        this.selectedCalIds = []
      } else {
        this.selectedCalIds = []
        this.calendars.forEach(calendar => this.selectedCalIds.push(calendar.id))
      }
    },
    deleteDays () {
      this.isDeleting = true
      const from = moment(this.fromDate).startOf('day')
      const to = moment(this.toDate).endOf('day')
      let index = 0
      const cals = JSON.parse(JSON.stringify(this.selectedCalIds))
      const dInterval = setInterval(_ => {
        const calId = cals[index]
        if (!calId) {
          clearInterval(dInterval)
          this.isDeleting = false
        }
        const idx = this.selectedCalIds.indexOf(calId)
        this.selectedCalIds.splice(idx, 1)
        index++
        if (calId) {
          const calName = this.allCalendarsInHash[calId] ? this.allCalendarsInHash[calId].name : ''
          docendo.deleteEventsRange(calId, from, to, success => {
            eventbus.toast = {text: 'Deleted days in ' + calName, success: true}
          }, failure => {
            eventbus.toast = {text: 'Something went wrong!', success: false}
            console.log('failed', failure)
          })
        }
      }, 1000)
    },
    toggleIsAccOpen () {
      if (!this.isAccOpen) {
        this.isAccOpen = true
      } else {
        this.isAccOpen = false
        this.selectedCalIds = []
      }
    }
  },
  mounted () {
    if (this.isOpen) {
      this.isAccOpen = true
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-acc {
  background: #ffffff;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.d-acc ul {
  border: 1px solid #d8d8d8;
  border-top: none;
  border-radius: 0 0 4px 4px;
  margin: 0;
}

.d-acc ul li {
  user-select: none;
}

.d-acc__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
  border: 1px solid #d8d8d8;
  padding: 1rem;
  border-radius: 4px;
  cursor: pointer;
  transition: border-color 0.25s;
}

.d-acc:not(.d-acc--open) .d-acc__header:hover {
  border-color: var(--blue);
}

.d-acc--open .d-acc__header {
  border-radius: 4px 4px 0 0;
}

.d-acc__header__left {
  display: flex;
  align-items: center;
}

.d-acc__header__select-all {
  cursor: pointer;
}

.d-copy-cals__list li:nth-child(odd) {
  background: #f8fafb;
}

.d-copy-cals__cal {
  padding: 0.25rem 1rem;
  display: flex;
  align-items: center;
  border-top: 1px solid transparent;
  cursor: pointer;
}

.d-copy-cals__list li.d-copy-cals__cal.d-copy-cals__cal--selected {
  border-top: 1px solid #fff;
  background-color: rgba(77, 138, 207, .3);
}

.d-copy-cals__list__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 20px;
}

.d-copy-cals__list li.d-copy-cals__cal:hover {
  color: var(--blue);
}

.d-copy-cals__cal__selector {
  width: 80px;
  padding-left: 20px;
  cursor: pointer;
  position: relative;
  display: inline-block;
  height: 25px;
  line-height: 25px;
  font-size: 1rem;
  user-select: none;
}

.checkbox {
  position: absolute;
  top: 0;
  left: 20px;
  width: 18px;
  height: 18px;
  z-index: 0;
  border: 2px solid #5a5a5a;
  border-radius: 1px;
  margin-top: 3px;
  transition: .2s;
}

.d-copy-cals__cal--selected .checkbox {
  top: -4px;
  left: 15px;
  width: 12px;
  height: 22px;
  border-top: 2px solid transparent;
  border-left: 2px solid transparent;
  border-right: 2px solid #26a69a;
  border-bottom: 2px solid #26a69a;
  transform: rotate(40deg);
  backface-visibility: hidden;
  transform-origin: 100% 100%;
}

.d-acc__header__select-all {
  font-size: 1rem;
  width: 80px;
}

.d-copy-cals__list__header__right {
  display: flex;
  align-items: center;
  text-decoration: none !important;
}

.d-copy-cals__list__header__right > p {
  margin-right: 1rem;
}

.d-toggle-arrow {
  width: 7px;
  height: 7px;
  border: 2px solid var(--dark-blue);
  border-width: 2px 2px 0 0;
  transform: rotate(45deg);
  margin-right: 1rem;
  transition: transform 0.25s;
}

.d-toggle-arrow.d-toggle-arrow--open {
  transform: rotate(135deg);
}

.archived-cals-toggler {
  display: flex;
  align-items: center;
  padding: 1rem 3rem;
  font-weight: bold;
  cursor: pointer;
}

.archived-cals-toggler:hover {
  color: var(--blue);
}

.archived-cal {
  padding: 0.25rem 1rem;
  padding-left: 92px;
}

.bttn--small {
  margin-left: 1rem;
  font-size: 0.9rem;
}

button.bttn--with-spinner {
  display: inline-flex;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// CalendarsDeleteEventsInDays.vue?3abcb494